import { render } from "./SukuBungaView.vue?vue&type=template&id=b36296e0"
import script from "./SukuBungaView.vue?vue&type=script&lang=js"
export * from "./SukuBungaView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__